import { Moment } from 'moment/moment';
import { DataConversionCalculationDto } from './data-conversion.model';

export class DataConversionCacheItem {
  data: DataConversionCalculationDto;
  expiresAt: Moment;
}
